const { localDateString } = require('./dates');
const { nextDueDate, frequencyStep } = require('../shared/taskSchedule');

function dueKey(value) {
  return String(value || '').slice(0, 10);
}

function taskFrequency(task) {
  return task && (task.task?.frequency || task.frequency);
}

function occurrenceDue(task, now = new Date()) {
  if (!task) return null;
  const frequency = taskFrequency(task);
  const base = task.due_date || localDateString(task.completed_at || now);
  return nextDueDate(base, frequency);
}

function nextOpenOccurrence(tasks, source, now = new Date()) {
  if (!source || !source.task_id) return null;
  const frequency = taskFrequency(source);
  const step = frequencyStep(frequency);
  if (!frequency || step.once) return null;
  const due = occurrenceDue(source, now);
  if (!due) return null;
  const open = (tasks || []).some((task) =>
    task
    && task.id !== source.id
    && task.task_id === source.task_id
    && dueKey(task.due_date) === due
    && !task.completed
  );
  if (open) return null;
  return {
    client_id: source.client_id,
    task_id: source.task_id,
    due_date: due,
    generated_from: source.id,
  };
}

function isUntouched(task) {
  return !task.completed && !task.completed_at && !task.notes && !task.client_notes;
}

function createdAfterCompletion(task, completedAt) {
  if (!task || !task.created_at || !completedAt) return false;
  const created = new Date(task.created_at).getTime();
  const done = new Date(completedAt).getTime();
  if (Number.isNaN(created) || Number.isNaN(done)) return false;
  return created >= done;
}

/**
 * The occurrence this completion created, still unused.
 * Prefer generated_from. A linked row that already has notes or a completion
 * is left alone. Without that link, only an untouched row for the computed
 * due date that was created at or after this completion qualifies. An older
 * duplicate with the same due date does not.
 */
function untouchedSpawn(tasks, source, dueDate) {
  if (!source || !source.id) return null;
  const rows = tasks || [];
  const linked = rows.filter((task) => task.id !== source.id && task.generated_from === source.id);
  if (linked.length) {
    return linked.find(isUntouched) || null;
  }
  if (!source.task_id || !dueDate || !source.completed_at) return null;
  const wanted = dueKey(dueDate);
  const matches = rows.filter((task) =>
    task.id !== source.id
    && task.task_id === source.task_id
    && dueKey(task.due_date) === wanted
    && isUntouched(task)
    && createdAfterCompletion(task, source.completed_at)
  );
  matches.sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
  return matches[0] || null;
}

module.exports = {
  localDateString,
  nextDueDate,
  occurrenceDue,
  nextOpenOccurrence,
  untouchedSpawn,
};
